module.exports = __webpack_public_path__ + "img/122.cbf6a879.svg";